import { Directive, input } from '@angular/core';
import { IProjectTab } from 'app/shared/interfaces/iproject-tab';

@Directive()
export class ProjectBaseScenarioTabItemComponent {

  readonly projectTab = input<IProjectTab>(undefined);
}